import {
  FETCHING_INTEGRATIONS_REQUEST, FETCHING_INTEGRATIONS_SUCCEDDED, FETCHING_INTEGRATIONS_FAILED
} from 'constants/actionTypes';

const initialState = {
  loading: true,
  items: [],
  error: null
};

function integrationsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_INTEGRATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case FETCHING_INTEGRATIONS_SUCCEDDED:
      return {
        ...state, 
        loading: false,
        items: action.payload
      }
    case FETCHING_INTEGRATIONS_FAILED:
      return {
        ...state, 
        loading: false,
        error: action.payload
        
      }
    default:
    return state
  }
}

export { integrationsReducer };
